import React, { useEffect, useRef, useState } from "react";
import EvaluatorLayout from "../../../components/evaluator-layout";
import EvaluationFormLayout from "../../../components/evaluation-form-layout";
import EvaluationFormProfile from "../../../components/evaluation-form-profile";
import { useNavigate, useSearchParams } from "react-router-dom";
import { isWithinRadius, onCheckFriendStatusLineLiff, onCloseLineLiff, onLoginLineLiff, onSleep } from "../../../utils/default";
import CoreAPI from "../../../services/core";
import LoadingModal from "../../../components/loading-modal";
import LandingPage from "../../../components/landing-page";
import EvaluationFormSelect from "../../../components/evaluation-form-select";
import SuccessModal from "../../../components/modal/success";
import EvaluationFormLanding from "../../../components/evaluation-form-landing";
import EvaluationFormNoData from "../../../components/evaluation-form-no-data";

function EvaluatorEvalutionFormPage() {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const searchParamsRef = useRef({
        evaluator_id: null,
        line_user_id: null,
        evaluation_form_id: null,
        from: null,
        mode: null,
    })
    const haveHistory = useRef(false)
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState("landing")
    const [back, setBack] = useState(false)
    const [evaluationFormData, setEvaluationFormData] = useState({
        evaluator_profile: {
            type: "",
            firstname: "",
            lastname: "",
            mobile_number: "",
            birthdate: null,
            province: "",
        }
    })
    const [evaluationFormDetail, setEvaluationFormDetail] = useState(null)
    const [evaluatorProfile, setEvaluatorProfile] = useState(null)
    const [listEvaluationFormData, setListEvaluationFormData] = useState([])
    const listSportCategoryRef = useRef([])
    const [detailPageForm, setDetailPageForm] = useState({
        currentPage: 1,
        groupIndex: 0,
        subFormIndex: 0,
    })
    const formCurrentPageRef = useRef("first_form")
    const [actionHeader, setActionHeader] = useState({
        back: false,
        close: false,
    })
    const [showHistory, setShowHistory] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [detailModal, setDetailModal] = useState({
        title: "ไม่พบข้อมูลแบบประเมิน",
        sub_title: "",
        type: "fail",
        button_label: "ตกลง",
        from: "",
    });
    const noDataType = useRef("not_found");

    useEffect(() => {
        onInit();
    }, [])
    useEffect(() => {
        if (page === "select") {
            setActionHeader({
                back: false,
                close: true,
            })
        } else if (page === "form") {
            if (searchParamsRef.current.from === "select") {
                setActionHeader({
                    back: true,
                    close: false,
                })
            } else {
                if (formCurrentPageRef.current === "profile") {
                    setActionHeader({
                        back: true,
                        close: false,
                    })
                } else {
                    setActionHeader({
                        back: false,
                        close: false,
                    })
                }
            }
            formCurrentPageRef.current = "";
        } else if (page === "profile") {
            setActionHeader({
                back: true,
                close: false,
            })
        } else if (page === "ef_landing") {
            if (searchParamsRef.current.from === "select") {
                setActionHeader({
                    back: true,
                    close: false,
                })
            } else {
                setActionHeader({
                    back: false,
                    close: false,
                })
            }
        }
    }, [page])

    async function onInit() {
        setIsLoading(true);
        localStorage.removeItem("evaluation_form_id");
        searchParamsRef.current.evaluator_id = searchParams.get("evaluator_id");
        searchParamsRef.current.line_user_id = searchParams.get("line_user_id");
        searchParamsRef.current.evaluation_form_id = searchParams.get("evaluation_form_id");
        searchParamsRef.current.from = searchParams.get("from");
        searchParamsRef.current.mode = searchParams.get("mode");
        // ========== ========== ========== ==========
        noDataType.current = "not_found";
        const liffResponse = await onLoginLineLiff(window.location.href);

        // 1. Prioritize LIFF User
        if (liffResponse?.profile?.userId) {
            let evaluatorByLiff = await onGetEvaluatorByLineUserId(liffResponse.profile.userId);
            if (evaluatorByLiff?.evaluator_id) {
                const newParams = new URLSearchParams(searchParams);
                newParams.set("evaluator_id", evaluatorByLiff.evaluator_id);
                newParams.set("line_user_id", liffResponse.profile.userId);
                setSearchParams(newParams);

                // Update ref for consistency in this render cycle if needed elsewhere
                searchParamsRef.current.evaluator_id = evaluatorByLiff.evaluator_id;
                searchParamsRef.current.line_user_id = liffResponse.profile.userId;
            }
        }

        let evaluator = null;
        if (searchParamsRef.current.evaluator_id) {
            evaluator = await onGetEvaluatorById(searchParamsRef.current.evaluator_id);
        } else if (searchParamsRef.current.line_user_id) {
            evaluator = await onGetEvaluatorByLineUserId(searchParamsRef.current.line_user_id);
        }

        if (evaluator === undefined || evaluator === null) {
            // fallback if step 1 didn't find anyone (e.g. not logged in to LINE or no user found yet)
            // but we already tried logging in at the top.
            // We can check if liffResponse was successful but maybe onGetEvaluatorByLineUserId returned null?
            // The original code tried login here. Since we moved it up, we don't need to call it again unless we want to force it?
            // But let's assume the top call handled the login part.
            if (liffResponse?.profile?.userId) {
                evaluator = await onGetEvaluatorByLineUserId(liffResponse.profile.userId);
            }
        }
        await onGetSportCategory();
        if (evaluator) {
            searchParamsRef.current.evaluator_id = evaluator.evaluator_id;
            searchParamsRef.current.line_user_id = evaluator.line_user_id;
            if (searchParamsRef.current.mode === "anonymous") {
                if (searchParamsRef.current.evaluation_form_id) {
                    const responseEF = await onGetEvaluationForm(null, searchParamsRef.current.evaluation_form_id);
                    if (responseEF && responseEF.message === "success") {
                        onSaveEvaluatorServiceHistory(searchParamsRef.current.evaluation_form_id, responseEF?.evaluator_profile?.evaluator_id, responseEF?.location_data?.location_id)
                        setPage("form");
                        setBack(false)
                    } else {
                        if (responseEF) {
                            noDataType.current = responseEF.message;
                        }
                        setPage("nodata")
                    }
                }
            } else {
                setEvaluatorProfile(evaluator)
                if (searchParamsRef.current.evaluation_form_id) {
                    const response = await onGetEvaluatorHistoryByParam(evaluator.evaluator_id, searchParamsRef.current.evaluation_form_id);
                    if (response?.message === "success" && response?.data) {
                        const checkRadius = await onCheckCoodinate(response?.data.coordinate);
                        if (checkRadius) {
                            let detail = {
                                ...response.data.evaluation_data,
                            }
                            detail.evaluator_profile = {
                                ...evaluator,
                            }
                            if (response.data.location_id) {
                                detail.location_data = {
                                    location_id: response.data.location_id,
                                }
                            }
                            if (detail.evaluation_form) {
                                detail.evaluation_form = onSetSportCategoryComponent(detail.evaluation_form)
                            }
                            setEvaluationFormData(detail)
                            setEvaluationFormDetail(response.data.evaluation_form_detail)
                            haveHistory.current = true;
                            setPage("ef_landing")
                        } else {
                            noDataType.current = "out_area";
                            setPage("nodata")
                        }
                    } else {
                        const responseEF = await onGetEvaluationForm(evaluator, searchParamsRef.current.evaluation_form_id);
                        if (responseEF && responseEF.message === "success") {
                            onSaveEvaluatorServiceHistory(searchParamsRef.current.evaluation_form_id, responseEF?.evaluator_profile?.evaluator_id, responseEF?.location_data?.location_id)
                            setEvaluationFormDetail(responseEF.evaluation_form_detail)
                            haveHistory.current = false;
                            setPage("ef_landing")
                        } else {
                            if (responseEF) {
                                noDataType.current = responseEF.message;
                            }
                            setPage("nodata")
                        }
                    }
                } else {
                    await onGetListEvaluationFormByParam();
                }
            }
        } else {
            if (!searchParamsRef.current.evaluation_form_id) {
                // navigate('/');
                setPage("nodata")
            } else {
                const responseEF = await onGetEvaluationForm(null, searchParamsRef.current.evaluation_form_id);
                if (responseEF && responseEF.message === "success") {
                    onSaveEvaluatorServiceHistory(searchParamsRef.current.evaluation_form_id, responseEF?.evaluator_profile?.evaluator_id, responseEF?.location_data?.location_id)
                } else {
                    if (responseEF) {
                        noDataType.current = responseEF.message;
                    }
                    setPage("nodata")
                }
            }
        }
        await onSleep(500);
        setIsLoading(false);
    }
    async function onGetEvaluatorHistoryByParam(evaluator_id, evaluation_form_id) {
        let response = null;
        try {
            let body = {
                evaluation_form_id: evaluation_form_id,
                evaluator_id: evaluator_id,
            }
            response = await CoreAPI.satHttpService.getEvaluatorHistoryByParam(body);
        } catch { }
        return response;
    }
    async function onGetEvaluationForm(evaluator, evaluation_form_id) {
        let response = null;
        let _detail;
        try {
            let body = {
                evaluation_form_id: evaluation_form_id,
                evaluator_id: evaluator?.evaluator_id,
            }
            response = await CoreAPI.satHttpService.getEvaluationFormByParam(body);
        } catch { }
        if (response?.message === "success") {
            _detail = {
                ...response.evaluation_data,
            }
            _detail.message = response.message;
            _detail.coordinate = response.coordinate;
            _detail.location_data = {
                ...response.location_data
            };
            _detail.evaluation_form_detail = {
                ...response.evaluation_form_detail
            };
            if (evaluator) {
                _detail.evaluator_profile = {
                    ...evaluator,
                    type: "",
                    mobile_number: evaluator?.mobile_number || "",
                    birthdate: evaluator?.birthdate ? new Date(evaluator.birthdate) : null,
                    province: evaluator?.province || "",
                }
            }
        } else {
            if (response) {
                _detail = {
                    message: response.message
                };
            } else {
                _detail = {
                    message: "not_found"
                };
            }
        }
        const isWithinRadius = await onCheckCoodinate(_detail?.coordinate);
        if (!isWithinRadius) {
            _detail = {
                message: "out_area"
            };
        }
        setDetailPageForm({
            currentPage: 1,
            groupIndex: 0,
            subFormIndex: 0,
        })
        if (_detail.evaluation_form) {
            _detail.evaluation_form = onSetSportCategoryComponent(_detail.evaluation_form)
        }
        setEvaluationFormData(_detail)
        return _detail;
    }
    async function onGetEvaluatorById(id) {
        let response = null;
        try {
            response = await CoreAPI.satHttpService.getEvaluatorById(id);
        } catch { }
        return response;
    }
    async function onGetEvaluatorByLineUserId(id) {
        let response = null;
        try {
            let body = {
                line_user_id: id,
            }
            response = await CoreAPI.satHttpService.upsertEvaluatorByLineUserIdDto(body);
        } catch { }
        return response;
    }
    async function onGetListEvaluationFormByParam() {
        const latlon = await onGetCurrentLocation();
        if (!latlon) {
            setPage("landing");
            return;
        }
        let response = null;
        try {
            let body = {
                ...latlon,
            }
            response = await CoreAPI.satHttpService.getListEvaluationFormByParam(body);
        } catch { }
        if (response) {
            setListEvaluationFormData(response)
        }
        setPage("select");
    }
    async function onGetSportCategory() {
        let response = null;
        try {
            response = await CoreAPI.evaluationFormHttpService.evaluationFormGetSportCategory()
        } catch { }
        if (Array.isArray(response)) {
            listSportCategoryRef.current = [...response];
        }
        return response;
    }
    async function onSaveEvaluationFormHistory(param) {
        let response = null;
        try {
            let detail = {
                ...param
            }
            delete detail['location_data']
            let body = {
                evaluation_form_id: searchParamsRef.current.evaluation_form_id || null,
                evaluator_id: param.evaluator_profile?.evaluator_id || null,
                evaluation_data: detail,
                location: null,
                location_id: param?.location_data?.location_id || null,
            }
            response = await CoreAPI.satHttpService.saveEvaluationFormHistory(body);
        } catch { }
        return response;
    }
    async function onSaveEvaluatorServiceHistory(evaluation_form_id, evaluator_id, location_id) {
        let response = null;
        try {
            let body = {
                evaluation_form_id,
                evaluator_id,
                location_id,
                anonymous: searchParamsRef.current.mode === "anonymous" ? true : false,
            }
            response = await CoreAPI.satHttpService.saveEvaluatorServiceHistory(body);
        } catch { }
        return response;
    }
    async function onUpdateEvaluator(param) {
        let response = null;
        try {
            let body = {
                evaluator_id: searchParamsRef.current.evaluator_id,
                ...param,
            }
            response = await CoreAPI.satHttpService.updateEvaluatorProfile(body);
        } catch { }
        return response;
    }
    function onGetCurrentLocation() {
        return new Promise((resolve) => {
            navigator.geolocation.getCurrentPosition((position) => {
                resolve({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                })
            }, (error) => {
                resolve(null)
            });
        })
    }
    async function onCheckCoodinate(param) {
        let check = true;
        if (param?.latitude && param?.longitude && param?.radius) {
            const latlon = await onGetCurrentLocation();
            if (latlon) {
                const checkRadius = isWithinRadius(param.latitude, param.longitude, latlon.latitude, latlon.longitude, param.radius);
                if (!checkRadius) {
                    check = false;
                }
            } else {
                check = false;
            }
        }
        return check;
    }
    function onSetSportCategoryComponent(param) {
        const detail = {
            "tag": "ประเภทกีฬา",
            "type": "dropdown_filter",
            "title": "ประเภทกีฬา",
            "answer": null,
            // "choice": [
            //     {
            //         "label": "ฟุตบอล",
            //         "value": "ฟุตบอล"
            //     },
            //     {
            //         "label": "บาสเกตบอล",
            //         "value": "บาสเกตบอล"
            //     },
            //     {
            //         "label": "เทเบิลเทนนิส	",
            //         "value": "เทเบิลเทนนิส	"
            //     }
            // ],
            "choice": [...listSportCategoryRef.current],
            "required": false,
            "hidden": true
        }
        for (let item of param) {
            if (item.form_type === "single_level") {
                const indexSporter = item.form?.findIndex(x => x.tag === "ประเภทผู้ประเมิน");
                const indexSportCategory = item.form?.findIndex(x => x.tag === "ประเภทกีฬา");
                if (indexSporter >= 0 && indexSportCategory < 0) {
                    item.form.splice(indexSporter + 1, 0, detail);
                    break;
                }
            } else if (item.form_type === "group_level") {
                // console.log(item)
            }
        }
        return param;
    }
    // ========== ========== ========== ==========
    async function handleConfirmConsent() {
        let detail = {
            ...evaluatorProfile,
            consent: true,
        }
        setEvaluatorProfile(detail);
        await onUpdateEvaluator(detail);
    }
    function handleClickBack() {
        setBack(true)
        if (page === "ef_landing") {
            if (searchParamsRef.current.from === "select") {
                navigate(`/evaluator/evaluation_form?evaluator_id=${evaluatorProfile.evaluator_id}`);
                window.location.reload();
            } else {
                navigate('/');
            }
        }
    }
    function handleClickClose() {
        onCloseLineLiff();
        navigate('/');
    }
    // ========== ========== ========== ==========
    function handleBackFormProfile(param) {
        setBack(false)
        formCurrentPageRef.current = param;
        if (param === "profile") {
            setPage("form");
        }
    }
    function handleBackForm(param, detail) {
        setBack(false);
        if (param === "first_form") {
            if (searchParamsRef.current.from === "select") {
                navigate(`/evaluator/evaluation_form?evaluator_id=${evaluatorProfile.evaluator_id}`);
                window.location.reload();
            }
        } else {
            if (detail.currentPage === 1 && detail.groupIndex === 0 && detail.subFormIndex === 0) {
                if (searchParamsRef.current.from === "select") {
                    setActionHeader({
                        back: true,
                        close: false,
                    })
                } else {
                    setActionHeader({
                        back: false,
                        close: false,
                    })
                }
            } else {
                setActionHeader({
                    back: true,
                    close: false,
                })
            }
        }
    }
    function handleNextForm(param, detail) {
        setActionHeader({
            back: true,
            close: false,
        })
    }
    function handleEvaluationFormData(param, detail) {
        setEvaluationFormData(param);
    }
    function handleEndEvaluationForm(param, detail) {
        setPage("profile");
        setDetailPageForm(detail)
    }
    function handleUpdateEvaluationFormHistory(param) {
        setShowHistory(param)
    }
    async function handleSaveAll(type, param) {
        setIsLoading(true);
        let detail = {
            ...evaluationFormData,
        }
        detail.evaluator_profile = {
            ...detail.evaluator_profile,
            ...param
        }
        if (type === "edit") {
            await onUpdateEvaluator(detail.evaluator_profile);
        }
        await onSaveEvaluationFormHistory(detail);
        await onGetEvaluationForm();
        await onCheckFriendStatusLineLiff();
        if (searchParamsRef.current.from === "select") {
            navigate(`/evaluator/evaluation_form?evaluator_id=${evaluatorProfile.evaluator_id}`);
            window.location.reload();
        } else {
            onCloseLineLiff();
            navigate('/');
        }
        await onSleep(500);
        setIsLoading(false);
    }
    function handleSelectEF(param) {
        navigate(`/evaluator/evaluation_form?evaluator_id=${evaluatorProfile.evaluator_id}&evaluation_form_id=${param.evaluation_form_evaluation_form_id}&from=select`);
        window.location.reload();
    }
    async function handleConfirmEF(param) {
        if (!evaluatorProfile.consent) {
            handleConfirmConsent();
        }
        if (param === "old") {
            onSaveEvaluatorServiceHistory(searchParamsRef.current.evaluation_form_id, evaluatorProfile?.evaluator_id, evaluationFormData?.location_data?.location_id)
            await handleSaveAll("", evaluatorProfile)
        } else if (param === "new") {
            setIsLoading(true);
            const responseEF = await onGetEvaluationForm(evaluatorProfile, searchParamsRef.current.evaluation_form_id);
            if (responseEF && responseEF.message === "success") {
                onSaveEvaluatorServiceHistory(searchParamsRef.current.evaluation_form_id, responseEF?.evaluator_profile?.evaluator_id, responseEF?.location_data?.location_id)
                setPage("form");
                setBack(false)
                await onSleep(500);
                setIsLoading(false);
            } else {
                if (responseEF) {
                    noDataType.current = responseEF.message;
                }
                setPage("nodata")
            }
        }
    }
    async function handleConfirmNoEF() {
        navigate(`/evaluator/evaluation_form?evaluator_id=${evaluatorProfile.evaluator_id}`);
        window.location.reload();
    }

    return (
        <EvaluatorLayout
            onClickBack={handleClickBack}
            onClickClose={handleClickClose}
            page={page}
            showBack={actionHeader.back}
        // showClose={actionHeader.close}
        >
            <SuccessModal
                open={openModal}
                onConfirm={handleConfirmNoEF}
                title={detailModal.title}
                subTitle={detailModal.sub_title}
                type={detailModal.type}
                buttonLabel={detailModal.button_label}
                styleContainer={{ maxWidth: "200px" }}
            />
            {page === "nodata" &&
                <EvaluationFormNoData type={noDataType.current} />
            }
            {page === "landing" &&
                <LandingPage />
            }
            {page === "ef_landing" &&
                <EvaluationFormLanding
                    evaluationForm={evaluationFormDetail}
                    haveHistory={haveHistory.current}
                    evaluator={evaluatorProfile}
                    onConfirm={handleConfirmEF}
                />
            }
            {page === "select" &&
                <EvaluationFormSelect
                    list={listEvaluationFormData}
                    onClickSelect={handleSelectEF}
                />
            }
            {page === "form" &&
                <EvaluationFormLayout
                    back={back}
                    onBack={handleBackForm}
                    onNext={handleNextForm}
                    evaluationFormData={evaluationFormData}
                    detailPageForm={detailPageForm}
                    evaluationFormHistory={showHistory}
                    onUpdateEvaluationFormHistory={handleUpdateEvaluationFormHistory}
                    onUpdateEvaluationFormData={handleEvaluationFormData}
                    onEndEvaluationForm={handleEndEvaluationForm}
                />
            }
            {page === "profile" &&
                <EvaluationFormProfile
                    back={back}
                    onBack={handleBackFormProfile}
                    evaluationFormData={evaluationFormData}
                    anonymous={searchParamsRef.current.mode === "anonymous" ? true : false}
                    onClickSave={handleSaveAll}
                />
            }
            <LoadingModal open={isLoading} />
        </EvaluatorLayout>
    )
}

export default EvaluatorEvalutionFormPage;